// sizes are in pixels
export const StateDefaultSize = 50;
export const StateMinSize = 35;
export const StateMaxSize = 130;
